import React, { ReactElement } from 'react';
import { FormOnSubmit, HTMLFormElementWithApi } from 'components/form';
import { ModalFormContent } from 'components/form/ModalFormContent';
import {
  EnterPinFormData,
  getFormDefaultValues,
  getFormInputsHook,
} from './EnterPinStep.forms';

export type EnterPinStepProps = {
  closeDrawer: () => void;
  isLocked: boolean;
  onPinCaptured: (pin: string) => void;
};

export function EnterPinStep(props: EnterPinStepProps): ReactElement {
  const { closeDrawer, isLocked, onPinCaptured } = props;
  const formRef = React.useRef<HTMLFormElementWithApi<EnterPinFormData>>();

  const inputs = React.useMemo(() => {
    return getFormInputsHook({
      submitForm: () => {
        formRef.current.requestSubmit();
      },
    });
  }, [onPinCaptured]);

  const defaultValues = React.useMemo(() => getFormDefaultValues(), []);

  const onSubmit: FormOnSubmit<EnterPinFormData> = async (
    data,
  ): Promise<void> => {
    onPinCaptured(data.pin);
  };

  return (
    <ModalFormContent
      ref={formRef}
      setOpen={closeDrawer}
      inputs={inputs}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      actionText="Save"
      actionButtonEnabled={false}
      cancelText="Cancel"
      onCancel={closeDrawer}
      renderAbove={
        isLocked ? (
          <p className="odin-text-sm odin-text-gray-500 odin-mb-6 odin--mt-6">
            Your PIN is locked. Set a new PIN to unlock it.
          </p>
        ) : undefined
      }
    />
  );
}
